import stylis from "stylis"

export function formatAndScopeCss(scope, cssString) {
  const formatted = stylis(scope, cssString)

  // This is silly, but mobile Outlook doesn't like when curly braces around
  // media queries don't have spaces around them.
  return formatted.replaceAll("{", " { ").replaceAll("}", " } ")
}
